module.exports = __webpack_public_path__ + "img/26_205.757a9625.png";